var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcUsdt24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 40 40.005",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 .005h40v40h-40z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m39.4 24.842a20 20 0 1 1 -14.564-24.242 20 20 0 0 1 14.564 24.242z",
    fill: "#50af95",
    transform: "translate(0 -.001)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m78.837 52.348c-.139.01-.858.053-2.46.053-1.275 0-2.18-.038-2.5-.053-4.926-.217-8.6-1.074-8.6-2.1s3.677-1.883 8.6-2.1v3.35c.322.023 1.245.078 2.519.078 1.53 0 2.3-.064 2.434-.076v-3.354c4.916.219 8.585 1.077 8.585 2.1s-3.668 1.882-8.585 2.1zm0-4.549v-3h6.863v-4.569h-18.681v4.57h6.859v3c-5.575.256-9.768 1.361-9.768 2.684s4.193 2.427 9.768 2.684v9.607h4.958v-9.61c5.563-.256 9.748-1.359 9.748-2.682s-4.184-2.427-9.748-2.683z",
    fill: "#fff",
    transform: "translate(-56.347 -29.672)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUsdt24);
export default __webpack_public_path__ + "static/media/ic_usdt_24.5ab8778d1f32d159a15158675749e294.svg";
export { ForwardRef as ReactComponent };